// src/components/common/protectedRoute/ProtectedRoute.js
import React, { createContext, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import SubscriptionPromo from '../../Subscription/SubscriptionPromo';
import { useSubscription } from '../../../contexts/context/SubscriptionContext';

// Crear un contexto para el estado de autenticación
const AuthContext = createContext();

// Provider para envolver la aplicación
export const AuthProvider = ({ children, isAuthenticated, isCheckingAuth }) => {
  return (
    <AuthContext.Provider value={{ isAuthenticated, isCheckingAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook para usar el contexto de autenticación
const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    // Fallback: si no hay contexto, verificar directamente el token
    const token = localStorage.getItem('agthealth_token');
    if (!token) {
      return { isAuthenticated: false, isCheckingAuth: false };
    }
    
    try {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      if (tokenData.exp && tokenData.exp < currentTime) {
        localStorage.removeItem('agthealth_token');
        return { isAuthenticated: false, isCheckingAuth: false };
      }
      
      return { isAuthenticated: true, isCheckingAuth: false };
    } catch (error) {
      localStorage.removeItem('agthealth_token');
      return { isAuthenticated: false, isCheckingAuth: false };
    }
  }
  return context;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isCheckingAuth } = useAuth();
  const { isPro, isLoading, hasSubscription } = useSubscription();

  // Si aún se está verificando la autenticación
  if (isCheckingAuth) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    console.log("ProtectedRoute - No autenticado, redirigiendo a login");
    return <Navigate to="/" replace />;
  }

  // Mostrar spinner mientras se verifica la suscripción
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si está autenticado pero no es Pro, mostrar pantalla de suscripción
  if (!isPro && !hasSubscription) {
    console.log("ProtectedRoute - Usuario autenticado pero sin suscripción, mostrando promo");
    return <SubscriptionPromo />;
  }

  // Si está autenticado y es Pro, mostrar el contenido protegido
  console.log("ProtectedRoute - Usuario autenticado y con suscripción, mostrando contenido protegido");
  return children;
};

export default ProtectedRoute;